/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React from 'react';

import { CMSHTML, CMSImage } from '@swf/cms';
import type { AppFooterContent, ItemBlock } from '@swf/generated/cms/types/AppFooterContent';

import styles from '../AppFooterContentWidget.scss';

const Item: React.FC<ItemBlock & { alignment: AppFooterContent['item_alignment'] }> = ({
  title,
  image,
  body,
  alignment
}) =>
  title || image.asset || body.content ? (
    <div className={classNames(styles.gridItem, alignment && styles[alignment])}>
      <div className={classNames(styles.header, alignment && styles[alignment])}>
        <CMSImage {...image} className={styles.thumbnailImage} />
        {title}
      </div>
      <CMSHTML className={styles.body} {...body} />
    </div>
  ) : null;

export default Item;
